import Hidden from '@mui/material/Hidden';
import clsx from 'clsx';
import AppContentView from 'main/core/AppContentView';
import {useLayoutContext} from 'main/utility/AppContextProvider/LayoutContextProvider';
import {useUiWiseAppActionContext} from 'main/utility/AppContextProvider/UiWiseAppContextProvider';
import {useAuthUser} from 'main/utility/AuthHooks';
import {notEmpty} from 'main/utility/CommonUtil';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {onGetAppEndpoint, onGetMenuSpec} from 'redux/actions';
import {LayoutType} from 'shared/constants/AppEnums';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import MainContent from './MainContent';
import UiWiseAppLayoutContainer from './UiWiseAppLayoutContainer';
import UiWiseAppLayoutWrapper from './UiWiseAppLayoutWrapper';

const UiWiseAppLayout = () => {
  const {layoutType, headerType} = useLayoutContext();
  const {updateUiWiseMenuSpec} = useUiWiseAppActionContext();
  const menuSpecs = useSelector(({commonReducer}) => commonReducer.menuSpecs);
  const appEndPoint = useSelector(
    ({commonReducer}) => commonReducer.appEndPoint,
  );

  const dispatch = useDispatch();
  const {user} = useAuthUser();

  useEffect(() => {
    if (notEmpty(user)) {
      if (menuSpecs.length === 0) {
        dispatch(onGetMenuSpec());
      }
      if (appEndPoint.length === 0) {
        dispatch(onGetAppEndpoint());
      }
    }
  }, [dispatch, user, menuSpecs.length]);

  useEffect(() => {
    if (menuSpecs?.length > 0) updateUiWiseMenuSpec(menuSpecs);
  }, [menuSpecs, updateUiWiseMenuSpec]);

  return (
    <UiWiseAppLayoutContainer
      className={clsx({
        boxedLayout: layoutType === LayoutType.BOXED,
        framedLayout: layoutType === LayoutType.FRAMED,
      })}
    >
      <UiWiseAppLayoutWrapper
        className={clsx('uiWiseAppLayoutWrapper', {
          appMainFixedHeader: headerType === 'fixed',
        })}
      >
        <AppSidebar />
        <MainContent>
          <Hidden lgUp>
            <AppHeader />
          </Hidden>
          <AppContentView />
        </MainContent>
      </UiWiseAppLayoutWrapper>
    </UiWiseAppLayoutContainer>
  );
};

export default UiWiseAppLayout;
